<div class="modal-header">
  <h4 class="modal-title pull-left">Duplicate Report</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-sm-12">
      <p class="report-create-info">
        Company Information
      </p>
    </div>
  </div>

  <ng-container *ngFor="let entity of report.ENTITIES; let i = index;">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label class="rbv-label" [ngClass]="{'with-check': i === 0}">
                <ng-container *ngIf="report.IS_MULTIPLE_ENTITY === true">
                  {{i === 0 ? 'Primary Corporate Name' : ('Entity #'+ [i+1])}}
                </ng-container>

                <ng-container *ngIf="!(report.IS_MULTIPLE_ENTITY === true)">
                  Corporate Name
                </ng-container>
              </label>
              <input-data [type]="typeOfInput.TEXT" [(ngModel)]="entity.NAME"
                          [id]="entity.ID" [fieldName]="'DBA'" [maxLength]="maxlength"
                          [showButton]="false">
              </input-data>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label class="rbv-label">
                <ng-container *ngIf="report.IS_MULTIPLE_ENTITY === true">
                  {{i === 0 ? 'Primary Corporate DBA Name' : ('Entity #'+ [i+1] + ' DBA Name')}}
                </ng-container>

                <ng-container *ngIf="!(report.IS_MULTIPLE_ENTITY === true)">
                  DBA Name
                </ng-container>
              </label>
              <input-data [type]="typeOfInput.TEXT" [(ngModel)]="entity.DBA"
                          [id]="entity.ID" [fieldName]="'DBA'" [maxLength]="maxlength"
                          [showButton]="false">
              </input-data>
            </div>
          </div>
        </div>
      </ng-container>

  <div class="row">
    <div class="col-sm-12">
      <div class="form-group">
        <label class="rbv-label">
          Internal File Name
        </label>
        <input-data [type]="typeOfInput.TEXT" [(ngModel)]="report.INTERNAL_FILE_NAME"
                    [id]="report.ID" [fieldName]="'DBA'" [maxLength]="maxlength"
                    [showButton]="false">
        </input-data>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" (click)="onConfirm()">Duplicate</button>
</div>
